import { Outlet } from "react-router-dom";

const Exams = () => {
  return <Outlet />;
};

export default Exams;
